import type { Recipe } from '../../types'
import { image, ingredient, scaled, section } from '../helpers'

export const naans: Recipe = {
  slug: 'naans',
  title: 'Naans indiens',
  category: 'salé',
  description: 'Des naans souples et moelleux, avec possibilité de les garnir au Kiri.',
  image: image('naans'),
  tags: ['pain', 'four à pizza', 'ajustable'],
  meta: [
    { label: 'Pétrissage', value: '8 à 10 min' },
    { label: 'Repos', value: '1 h 30 à 2 h + 1 h après boulage' },
    { label: 'Alternative', value: 'une nuit au froid + 1 h après boulage' },
    { label: 'Cuisson', value: 'four à pizza à 375 °C' },
  ],
  scaler: {
    kind: 'linear',
    label: 'Nombre de naans',
    min: 2,
    max: 16,
    step: 1,
    base: 8,
    resultLabel: (value) => `${value} naans`,
  },
  sections: [
    section('Ingrédients', [
      scaled('farine', 'farine T45 ou T55', 500, 'g', {
        display: '500 g de farine T45 ou T55',
        shoppingKey: 'farine',
      }),
      scaled('sel', 'sel', 8, 'g', { display: '8 g de sel', shoppingKey: 'sel' }),
      scaled('levure', 'levure boulangère sèche', 7, 'g', {
        display: '7 g de levure boulangère sèche',
        shoppingKey: 'levure sèche',
      }),
      scaled('sucre', 'sucre', 1, 'c. à café', { display: '1 c. à café de sucre', shoppingKey: 'sucre' }),
      scaled('yaourt', 'yaourt entier', 120, 'g', {
        display: '120 g de yaourt entier type grec ou brassé (3 à 4 % MG)',
        shoppingKey: 'yaourt',
      }),
      scaled('huile', 'huile neutre ou ghee', 2, 'c. à soupe', {
        display: '2 c. à soupe d’huile neutre ou de ghee',
        shoppingKey: 'huile',
      }),
      scaled('eau', 'eau tiède', 220, 'g', { display: '220 g d’eau tiède', shoppingKey: 'eau' }),
    ]),
    section('Option', [
      scaled('levure-chimique', 'levure chimique', 0.5, 'c. à café', {
        display:
          '1/2 c. à café de levure chimique pour un résultat encore plus moelleux, avec un côté tandoor',
        optional: true,
      }),
      ingredient('kiri', 'Kiri', 'Du Kiri pour garnir l’intérieur avant l’abaisse, si souhaité', {
        optional: true,
        shoppingKey: 'kiri',
      }),
    ]),
  ],
  steps: [
    'Mélanger tous les ingrédients, puis pétrir 8 à 10 minutes jusqu’à obtenir une pâte souple, légèrement collante mais pas liquide.',
    'Laisser lever 1 h 30 à 2 h à température ambiante, ou une nuit au réfrigérateur pour un goût encore meilleur.',
    'Diviser ensuite en pâtons de 100 à 120 g.',
    'Former des boules sans trop les serrer, puis laisser détendre une heure avant la cuisson.',
    'Si vous souhaitez les farcir, insérer un peu de Kiri au centre, refermer soigneusement, puis abaisser délicatement.',
    'Étaler chaque naan sur 12 à 15 cm, avec 3 à 5 mm d’épaisseur au centre et des bords légèrement plus épais.',
    'Cuire au four à pizza à 375 °C jusqu’à ce que les naans soient bien gonflés et joliment colorés.',
  ],
}
